export default "__VITE_ASSET__OxJTiu5E__"